import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormUpload = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormUpload' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182' />
  </StyledIcon>
);
